import React from 'react';

import { Avatar, Button, Group, Paper, Stack, Text } from '@mantine/core';
import { StaffWithProfilePicture } from 'types/generated';

interface CoachSelectionStepProps {
  coaches: StaffWithProfilePicture[];
  athleteHasCredit: boolean;
  hasSalesPortalPackages: boolean;
  onSelectCoach: (staffId: string) => void;
}

const SelfBookingAppointmentCoachSelectionStep = ({
  coaches,
  athleteHasCredit,
  hasSalesPortalPackages,
  onSelectCoach,
}: CoachSelectionStepProps): JSX.Element => {
  if (!athleteHasCredit) {
    return (
      <Stack my='xl' spacing='md' ta='center'>
        <Text size='xl' weight={600}>
          Having trouble booking an appointment?
        </Text>

        <Text size='xl'>
          You might be missing valid credits to access it. Reach out to your gym or purchase a new package.
        </Text>

        {hasSalesPortalPackages && (
          <Group position='center' my='xl'>
            <Button component='a' href='/packages/sales-portal' size='md'>
              Explore Packages
            </Button>
          </Group>
        )}
      </Stack>
    );
  }

  return (
    <>
      <Text ta='center' size='lg'>
        Select the coach
      </Text>

      {coaches.map(coach => (
        <Paper
          key={coach.staffId}
          shadow='xs'
          radius='lg'
          py='md'
          px='xl'
          onClick={() => onSelectCoach(coach.staffId)}
          sx={{ cursor: 'pointer' }}
        >
          <Group noWrap>
            <Avatar size='lg' radius='xl' src={coach.profilePicture} />

            <Text size='lg' weight={700} lineClamp={1}>
              {coach.fullName}
            </Text>
          </Group>
        </Paper>
      ))}
    </>
  );
};

export default SelfBookingAppointmentCoachSelectionStep;
